import clsx from 'clsx'
import NextLink from 'next/link'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { Image } from '@/components/ui'
import { EXTERNAL_ROUTE, ROUTE } from '@/const'
import { useSession } from '@/hooks/features/auth'

const Link = ({
  href,
  text,
  external,
}: {
  href: string
  text: string
  external?: boolean
}) => {
  if (external) {
    return (
      <a href={href} target={'_blank'} rel="noreferrer">
        <span
          className={clsx(
            'tw-px-4',
            'tw-text-xs tw-text-white',
            'tw-transition tw-duration-stateChange hover:tw-opacity-hover'
          )}
        >
          {text}
        </span>
      </a>
    )
  }

  return (
    <NextLink href={href}>
      <span
        className={clsx(
          'tw-px-4',
          'tw-text-xs tw-text-white',
          'tw-transition tw-duration-stateChange hover:tw-opacity-hover'
        )}
      >
        {text}
      </span>
    </NextLink>
  )
}

export const Footer = () => {
  const { isAuthenticated } = useSession()
  const authenticated = useMemo(() => isAuthenticated, [isAuthenticated])
  const { t } = useTranslation()

  return (
    <div
      className={clsx(
        'tw-flex tw-flex-col',
        'tw-gap-2',
        'tw-p-4',
        'tw-bg-primary-500'
      )}
    >
      <div className={clsx('tw-flex tw-justify-center')}>
        <div
          className={clsx(
            'tw-w-[320px] lg:tw-w-pcMax',
            'tw-flex tw-justify-between lg:tw-justify-center lg:tw-space-x-8'
          )}
        >
          <div
            className={clsx(
              'tw-flex tw-flex-col tw-space-y-2 lg:tw-flex-row lg:tw-space-x-8 lg:tw-space-y-0'
            )}
          >
            {authenticated && (
              <Link
                href={ROUTE.guides}
                text={t('contact.menu.guide')}
                external
              />
            )}
            <Link href={ROUTE.contact} text={t('contact.menu.contact')} />
          </div>
          <div
            className={clsx(
              'tw-flex tw-flex-col tw-space-y-2 lg:tw-flex-row lg:tw-space-x-8 lg:tw-space-y-0'
            )}
          >
            <Link
              href={ROUTE.privacyPolicy}
              text={t('contact.menu.privacyPolicy')}
              external
            />
            <Link
              href={ROUTE.termsOfService}
              text={t('contact.menu.termsOfService')}
              external
            />
            <Link
              href={ROUTE.tokushoho}
              text={t('contact.menu.law')}
              external
            />
          </div>
        </div>
      </div>

      <div className={clsx('tw-mt-4 tw-flex tw-justify-center')}>
        <a
          href={EXTERNAL_ROUTE.corporateSite}
          target={'_blank'}
          rel={'noreferrer'}
          className={clsx('tw-block', 'tw-h-6')}
        >
          <Image
            src="/images/kikuya_logo.png"
            alt="kikuya logo"
            fit="contain"
          />
        </a>
      </div>

      <div className={clsx('tw-mt-2 tw-flex tw-justify-center')}>
        <p className={clsx('tw-text-2xs tw-text-white')}>
          {'Copyright KIKUYA-BISYODO Inc. All Rights Reserved.'}
        </p>
      </div>
    </div>
  )
}
